export default function () {
  window.dataLayer = window.dataLayer || [];
  // eslint-disable-next-line
  function gtag() { dataLayer.push(arguments); }
  gtag('js', new Date()); gtag('config', 'G-7WDED3KBBE');
}
